import axios from "axios";

// Resolve backend URL with this priority:
// 1. Explicit REACT_APP_BACKEND_URL build-time env var (escape hatch for
//    setups where backend lives on a different origin than the frontend).
// 2. Same-origin fallback (window.location.origin). This works in both
//    preview and production because the Kubernetes ingress routes
//    /api/* to the backend on the same domain.
const ENV_URL = process.env.REACT_APP_BACKEND_URL;
const BACKEND_URL =
  ENV_URL && ENV_URL !== "undefined"
    ? ENV_URL.replace(/\/$/, "")
    : (typeof window !== "undefined" ? window.location.origin : "");

export const API = `${BACKEND_URL}/api`;
export const BASE_URL = BACKEND_URL;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dosoft_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const LOGO_URL = "/img/dosoft-logo.png";

export function formatApiError(detail) {
  if (detail == null) return "Algo salió mal. Intenta nuevamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
